import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">WorshipGuard · Your Faith, Our Protection</p>
        <h1>Secure Your Sacred Space</h1>
        <p className="lede">
          At WorshipGuard, we specialize in providing comprehensive security and surveillance solutions tailored for religious institutions. Your peace of mind is our mission.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Comprehensive Protection</h2>
          <p>
            Our dedicated team offers customized security plans to ensure the safety of your congregation and property.
          </p>
        </article>
        <article>
          <h2>Advanced Surveillance</h2>
          <p>
            Utilize state-of-the-art surveillance technology to monitor your premises and deter potential threats.
          </p>
        </article>
        <article>
          <h2>Community Focused</h2>
          <p>
            We understand the unique needs of religious institutions and work closely with you to create a secure environment for worship.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;